import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class StorePrefixRemoverGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
    const newUrl = state.url.replace(/^\/store\/[^/]+/, '') || '/';
    return this.router.parseUrl(newUrl);
  }
}